import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import InventoryCountCreate from "./InventoryCountCreate";
import InventoryCountList from "./InvnetoryCountList";
import InventoryCountItemDetails from "./InventoryCountItemDetails";
import InventoryCountItemDetailsReview from "./InventoryCountItemDetailsReview";
const inventoryCount = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/listing`} />
    <Route path={`${match.url}/create`} component={InventoryCountCreate} />
    <Route path={`${match.url}/listing`} component={InventoryCountList} />
    <Route path={`${match.url}/:id/edit`} component={InventoryCountCreate} />
    <Route
      path={`${match.url}/:id/perform`}
      component={InventoryCountItemDetails}
    />
    <Route
      path={`${match.url}/:id/review`}
      component={InventoryCountItemDetailsReview}
    />
    <Route
      path={`${match.url}/:id`}
      component={InventoryCountItemDetailsReview}
    />
  </Switch>
);

export default inventoryCount;
